import { ConfigModel } from '../core/interfaces/config';

export class PagesConfig implements ConfigModel {
	public config: any = {};

	constructor() {
		this.config = {
			'/': {
				page: {
					title: 'Dashboard',
					desc: 'Latest updates and statistic charts'
				}
			},
			header: {
				actions: {
					page: { title: 'Actions', desc: 'actions example page' }
				}
			},
			profile: {
				page: { title: 'User Profile', desc: '' }
			},
			masterdata: {
				places: {
					page: { title: 'Places', desc: 'A list of available places' }
				},
				countries: {
					page: { title: 'Countries', desc: 'A list of available countries' }
				},
				currencies: {
					page: { title: 'Currencies', desc: 'A list of available currencies' }
				}
			},
			404: {
				page: { title: '404 Not Found', desc: '', subheader: false }
			}
		};
	}
}
